import { useAccountContext } from '../useAccountContext';

export const useCompanyInvoices = () => {
  const { currentCompany } = useAccountContext();

  return currentCompany?.invoices || [];
};
